<template>
	<div class="session">
		<SessionRecorder
			:contact-list="contactList"
			:pending-contacts.sync="pendingContacts"
			:recorder="user.recorder"
			:session-list="sessionList"
			:streaming="user.streaming"
		/>
		<SessionList
			v-if="sessionList.length > 0"
			:recorder="user.recorder"
			:session-list="sessionList"
		/>
		<favorite-dialog
			:user-id="user.user_id"
			@remove="getContactList"
			@update="getContactList"
		/>
	</div>
</template>

<script>
import FavoriteDialog from "session/ui/FavoriteDialog";
import SessionList from "session/List";
import SessionRecorder from "session/Recorder";
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";

import find from "lodash/find";

export default {
	name: "Session",
	components: {
		FavoriteDialog,
		SessionList,
		SessionRecorder
	},
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			contactList: [],
			pendingContacts: {},
			sessionList: []
		};
	},
	mounted() {
		$bus.$on("_session/Session.updateSessionList", this.updateSessionList);

		this.getContactList(false);
	},
	beforeDestroy() {
		$bus.$off("_session/Session.updateSessionList", this.updateSessionList);
	},
	methods: {
		// contact list
		getContactList(broadcast = true) {
			http.get(`/api/v2/user/${this.user.user_id}/contactlist?limit=1000`)
			.then((response) => {
				this.contactList = response.data;

				if (broadcast)
					$bus.$emit("_App.getSessionStatus");
			})
			.catch((error) => {
				alert.error("Unable to get contact list", error.response);
			});
		},
		// contact
		updateContact(sipUri, parameters) {
			http.post(`/api/v2/user/${this.user.user_id}/contact/${encodeURIComponent(sipUri)}`, parameters)
			.then(() => {
				this.getContactList();
			})
			.catch((error) => {
				alert.error("Unable to add/update favorite", error.response);
			});
		},
		// session list
		updateSessionList(sessionList) {
			this.sessionList.forEach((sessionItem) => {
				const session = find(sessionList, { session_id: sessionItem.session_id });

				if (!session && sessionItem.established === 0) {
					alert.error(`Unable to establish session to ${sessionItem.uri}`);
					delete this.pendingContacts[sessionItem.uri];
				}
			});

			sessionList.filter((session) => session.type === "sip").forEach((sessionItem) => {
				const contact = find(this.contactList, { uri: sessionItem.uri });
				const pendingContact = this.pendingContacts[sessionItem.uri];
				const localSessionItem = find(this.sessionList, { session_id: sessionItem.session_id });

				if (sessionItem.established === 1 && pendingContact) {

					if (contact) {
						pendingContact.favorite = contact.favorite;
						pendingContact.name = contact.name;
					}

					this.updateContact(sessionItem.uri, pendingContact);
					delete this.pendingContacts[sessionItem.uri];
				}

				sessionItem.contact = contact || {};

				if (localSessionItem)
					sessionItem._deleted = localSessionItem._deleted;
				else
					sessionItem._deleted = false;

				if (sessionItem.uri.includes("@web.rec"))
					sessionItem._hidden = localSessionItem && localSessionItem._hidden || false;
			});

			this.sessionList = sessionList;
		}
	}
};
</script>
